<template>
    <div class='reset_wrap'>
        
        <div class="main_wrap flex-column-center">
            <div class="back">
                <el-page-header @back="$core.goBack"></el-page-header>
            </div>
            <!-- <div class="logo_wrap">
                <i class="iconfont icon-maisiduowei"></i>
            </div> -->
            <!-- 头部 -->
            <!-- <div class="step_title">
                <el-steps  :active="activeItem" align-center>
                    <el-step title="确认账号"></el-step>
                    <el-step title="重置密码"></el-step>
                    <el-step title="重置成功"></el-step>
                </el-steps>
            </div> -->
            <div class="flex-around icon_title">
                <i class="iconfont icon-suo1">&nbsp;&nbsp;找回密码</i>
            </div>
            <!-- 第一步 -->
            <el-form  :model="phoneForm"   :rules="resetRules" ref="phoneForm"  label-width="120px">
                
                <div class="title">
                    <!-- <div class="sub_title">信息验证</div> -->
                    <div>
                        <el-form-item prop="phone"  label="手机号:">
                            <el-input v-model="phoneForm.phone" placeholder="11位手机号" maxlength="11" ></el-input>
                        </el-form-item>
                    </div>
                    <div class="flex-between" >
                        <el-form-item label="图形验证码:" prop="verifycontent">
                            <el-input  v-model="phoneForm.verifycontent" placeholder="请输入图形验证码"  ></el-input>
                        </el-form-item>
                        <img  @click="getverifyCode" :src="verifyCodeUrl" class="button-hover" title="看不清？换一张"/>
                    </div>
                    <div class="flex-between" >
                        <el-form-item label="手机验证码:" prop="phoneVerifyCode">
                            <el-input  v-model="phoneForm.phoneVerifyCode" placeholder="请输入手机验证码"  ></el-input>
                        </el-form-item >
                        <div>
                            <el-button type="primary" @click="submitCode"  v-if="!isabled">获取验证码</el-button>
                            <el-button type="info" plain v-else disabled>{{timer}}(s)后获取</el-button>
                        </div>
                    </div>
                </div>
                <!-- <div class="sub_btn title">
                    <el-button type="primary" @click="sureSubmit">提&nbsp;&nbsp;交</el-button>
                </div> -->
            </el-form>
            
            <!-- 第二步 -->
            <el-form class="register"  :model="resetForm" :rules="resetRules" ref="resetForm" label-width="120px">
                
                <div class="title">
                    <!-- <div  class="sub_title">密码重置</div> -->
                    <div>
                        <el-form-item prop="password" label="密码：">
                            <el-input  type="password"  placeholder="请输入新密码" v-model="resetForm.password" show-password></el-input>
                        </el-form-item>
                    </div>
                    <div>
                        <el-form-item prop="rePassword" label="重置密码：">
                            <el-input type="password"  placeholder="请再次输入密码" v-model="resetForm.rePassword" show-password></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="sub_btn flex-around">
                    <el-button type="primary" @click="resetSubmit">提&nbsp;&nbsp;交</el-button>
                </div>
            </el-form>
                
            <!-- 第三步 -->
            <!-- <div class="title" v-if="activeItem == 3">
                <div class="icont mat40"><i class="iconfont icon-chenggong"></i></div>
                <div class="title_tips mat40">您的账号密码重置成功！</div>
                <div class="sub_btn title">
                    <el-button @click="toLogin" type="primary">登录账号</el-button>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import {checkAndSendSMS,forgetPassword,getImage} from '../../../utils/api'
export default {
    data () {
        return {
            activeItem:1,
            verifyCodeUrl:'',
            uuid:'',
            isabled:false,
            timer:60,
            phoneForm:{
                phone:'',
                verifycontent:'',
                phoneVerifyCode:'',
            },
            resetForm:{
                password:'',
                rePassword:''
            },
            resetRules:{
                userName: [{ required: true, message: '请输入学生姓名', trigger: 'blur' }],
                verifycontent: [{ required: true, message: '请输入图形验证码', trigger: 'blur' }],
                phoneVerifyCode: [{ required: true, message: '请输入手机验证码', trigger: 'blur' }],
                read: [{ message: '请勾选用户协议', trigger: 'blur' }],
                workNumber: [{ required: true, message: '请阅读用户手册', trigger: 'change' }],
                occupation: [{ required: true, message: '请选择职业', trigger: 'change' }],
                schoolAppellationId: [{ message: '请选择学校', trigger: 'change' }],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { pattern: /^.{8,}$/, message: '请输入8-16位密码，区分大小写', trigger: 'blur' }
                ],
                rePassword: [
                    { required: true, message: '请确认密码', trigger: 'blur' },
                    { pattern: /^.{8,}$/, message: '请输入8-16位密码，区分大小写', trigger: 'blur' }
                ],
            }
        }
    },
    created(){
        this.getverifyCode()
    },
    methods:{
        // 点击获取图形验证码
        getverifyCode(){
            getImage().then(res => {
                this.verifyCodeUrl = res.data.image
                this.uuid = res.data.uuid_verify
            }).catch(err =>　{})
            this.tipsShow = true
        },

        // 提交图形验证码并发送手机验证码
        submitCode(){
            if(!this.phoneForm.phone || !this.phoneForm.verifycontent){
                return this.$message.error('请先输入手机号与图形验证码')
            }else{
                checkAndSendSMS(`${this.phoneForm.phone}/${this.phoneForm.verifycontent}/${this.uuid}`).then(res => {
                    this.$message.success('验证通过，请查收手机验证码')
                    // 手机验证码发送成功后禁用
                    let interval = setInterval(() => {
                    let obj =  this.$core.virifyCode(this.timer)
                    this.timer = obj.timer
                    this.isabled = obj.isabled
                    if(!obj.isabled){
                        this.timer = 60
                        clearInterval(interval)
                    }
                },1000)
                }).catch(err => {
                    this.getverifyCode()
                })
            }
        },

        // 下一步
        sureSubmit(){
            this.$refs.phoneForm.validate(valid => {
                if(!valid) return
                this.activeItem = 2
            })
            
        },

        // 重置密码
        resetSubmit(){
            if(this.resetForm.password != this.resetForm.rePassword){
                return this.$message('两次密码输入不一致!')
            }
            this.$refs.resetForm.validate(valid => {
                if(!valid) return
                forgetPassword(`${this.phoneForm.phone}/${this.phoneForm.phoneVerifyCode}`,{newPassword:this.resetForm.password}).then(res => {
                    this.activeItem = 3
                }).catch(err => {})
            })
        },

        // 跳转登陆页
        toLogin(){
            this.$router.push('/login')
        }
    }
}
</script> 

<style lang='scss' scoped>
.title_tips{
    font-size: 22px;
    color: #73D13D;
}
.icon-chenggong{
    font-size: 60px;
    color: #73D13D;
}
.logo_wrap{
    height: 120px;
    line-height: 120px;
    text-align: center;
    .icon-maisiduowei{
        font-size: 65px;
        color: #5277F7;
    }
    
}
.reset_wrap{
    height: 100vh;
    width: 100%;
    background: url(../../../assets/img/MS-A/regBg.png) 0 0/100% 100% no-repeat;
    .main_wrap {
        border-radius: 15px;
        padding: 15px 0px;
        position: fixed;
        z-index: 11;
        top: 20vh;
        left: 45vw;
        background: rgba(255,255,255,0.95);
        /deep/.el-form-item{
            margin-bottom: 0px;
        }
        /deep/ .el-input__inner{
            background-color: rgba(255, 255, 255, 0.247);
            // color: #fff;
            width: 100%;
        }
        /deep/ .el-textarea__inner{
            background-color: rgba(255, 255, 255, 0.247);
            
        }
        /deep/ .el-tabs__item{
            color: #fff;
            font-size: 18px;
        }
        /deep/ .el-tabs__item.is-active{
            color: #fff;
            font-size: 20px;
            font-weight: bold;
        }
        .step_title{
            /deep/.el-steps{
                margin: 30px 0 30px 20px;
            }
            width: 100%;
        }
        .back{
            position: relative;
            left: -15vw;
            top: -10vh;
        }
        .icon_title{
            margin-bottom: 80px;
            i{
                font-size: 32px;
                font-weight: bold;
                color: #333333;
            }
        }
        .title{
            box-sizing: border-box;
            width: 100%;
            // text-align: center;
            // padding: 20px 0px 20px 300px;
            .sub_title{
                font-size: 18px;
                font-weight: bold;
            }
            >div{
                margin-bottom: 20px;
            }
            
        }
        .sub_btn{
            margin-top: 60px;
            /deep/ .el-button{
                width: 100px;
                // margin-top: 60px;
                font-weight: bold;
            }
        }
        
    }
}    
</style>